import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Theme,
  Tooltip,
  Typography,
} from "@mui/material";
import { makeStyles } from "helpers/StyleHelper";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useIntl, FormattedMessage as T } from "react-intl";
import { IMenu, MenuRequest } from "services/KnowfullyAdminClient";
import { CommonFormProps } from "types/common-types";
import MenuForm from "./MenuForm";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuStructureList from "./MenuStructureList";

const useStyles = makeStyles((theme: Theme) => ({
  expandedPanel: {
    backgroundColor: theme.palette.secondary.light,
  },
}));

export type MenuAccordionsProps = {
  menuId?: string | undefined;
} & CommonFormProps<IMenu, MenuRequest>;

const MenuAccordions = ({
  menuId,
  entity: menu,
  onSubmit,
  onCancel,
  submitLabel,
}: MenuAccordionsProps) => {
  const styles = useStyles(useTheme());
  const { formatMessage: t } = useIntl();
  const [expandedSection, setExpandedSection] = useState<string | null>(
    "details"
  );

  const locked = menuId === undefined;

  const accordionProps = (section: string) => {
    return {
      square: true,
      expanded: expandedSection === section,
      onChange: toggleExpansion(section),
      disabled: locked && expandedSection !== section,
    };
  };

  const toggleExpansion = (section: string) => (e: any, expanded: boolean) => {
    if (locked || !menuId) return;
    setExpandedSection(expanded ? section : null);
  };

  return (
    <>
      <Accordion {...accordionProps("details")}>
        <AccordionSummary
          style={{ margin: 0 }}
          expandIcon={<ExpandMoreIcon />}
          sx={accordionProps("details").expanded ? styles.expandedPanel : null}
          data-cy="accordionSummaryButton"
        >
          <Typography>
            <T id="detailsLabel" />
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{display: "inherit"}}>
          <MenuForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            entity={menu}
            submitLabel={submitLabel}
          />
        </AccordionDetails>
      </Accordion>
      <Tooltip
        title={locked ? t({ id: "accordionDisabledToCreationMessage" }) : ""}
      >
        <Accordion {...accordionProps("structures")}>
          <AccordionSummary
            style={{ margin: 0 }}
            expandIcon={<ExpandMoreIcon />}
            sx={accordionProps("structures").expanded ? styles.expandedPanel : null}
          >
            <Typography>
              <T id="menuStructuresLabel" />
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MenuStructureList menuId={menuId!} />
          </AccordionDetails>
        </Accordion>
      </Tooltip>   
    </>
  );
};

export default MenuAccordions;
